import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Select from "react-select";

import Layouts from "../../layouts/layouts";

export default function Create_job() {
  const title = "Add Job Type";
  const [formData, setFormData] = useState({
    title: "",
    openings: "",
    status: "",
    city: "",
    comment: "",
    postingdetails: "",
  });
  const [autocomplete, setAutocomplete] = useState(null);
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  const brad = [{ name: "Home" }, { name: title }];
  const onChangeHandler = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const onLoad = (autoComp) => {
    setAutocomplete(autoComp);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.title) newErrors.title = "Title is required";
    if (!formData.openings) newErrors.openings = "Opneings Count is required";
    if (!formData.city) newErrors.city = "City is required";
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const formDataToSubmit = new FormData();
      formDataToSubmit.append("title", formData.title);
      formDataToSubmit.append("postingdetails", formData.postingdetails);

      formDataToSubmit.append("openings", formData.openings);
      formDataToSubmit.append("status", formData.status);
      formDataToSubmit.append("city", formData.city);
      formDataToSubmit.append("comment", formData.comment);

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/jobs`,
        formDataToSubmit,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 201) {
        navigate("/job");
      } else {
        console.error("Submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <Breadcrumb title={title} brad={brad} />
        <form
          className="card"
          style={{ borderTop: "2px solid #4723d9" }}
          onSubmit={onSubmitHandler}
        >
          <div className="card-header d-flex justify-content-between border-bottom pb-1">
            <div className="">{title}</div>
            <div className="btn btn-info btn-sm" onClick={() => navigate(-1)}>
              Back
            </div>
          </div>
          <div className="card-body">
            <div className="row justify-content-center">
              <div className="col-md-6 mt-3">
                <label htmlFor="title">
                  <b>Job Title *</b>
                </label>
                <input
                  type="text"
                  name="title"
                  placeholder="Title"
                  className="form-control"
                  value={formData.title}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="openings">
                  <b>Openings Count *</b>
                </label>
                <input
                  type="number"
                  name="openings"
                  placeholder="Openings"
                  className="form-control"
                  value={formData.openings}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="city">
                  <b>City *</b>
                </label>
                <input
                  type="text"
                  name="city"
                  placeholder="City"
                  className="form-control"
                  value={formData.city}
                  onChange={onChangeHandler}
                />
                {errors.city && (
                  <small className="text-danger">{errors.city}</small>
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="status">
                  <b> Status *</b>
                </label>
                <select
                  name="status"
                  className={`form-control ${
                    errors.status ? "is-invalid" : ""
                  }`}
                  value={formData.status}
                  onChange={onChangeHandler}
                >
                  <option value="">Select Status</option>
                  <option value="Open">Open</option>
                  <option value="Close">Close</option>
                </select>
                {errors.status && (
                  <div className="invalid-feedback">{errors.status}</div>
                )}
              </div>

              <div className="col-12 mt-3">
                <label htmlFor="postingdetails">
                  <b>Job Posting Details</b>
                </label>
                <textarea
                  type="text"
                  name="postingdetails"
                  placeholder="Job_Posting_Details"
                  rows="5"
                  className="form-control"
                  value={formData.postingdetails}
                  onChange={onChangeHandler}
                  spellCheck={true}
                ></textarea>
              </div>

              <div className="col-12 mt-3">
                <label htmlFor="comment">
                  <b>Comments</b>
                </label>
                <textarea
                  name="comment"
                  type="text"
                  placeholder="Comments"
                  rows="5"
                  className="form-control"
                  value={formData.comment}
                  onChange={onChangeHandler}
                ></textarea>
              </div>

              <div className="col-md-6 mt-3"></div>
            </div>
            <button type="submit" className="btn btn-primary btn-sm mt-3">
              Add Job Type
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
